/** Create a default map
 */

import Map from 'ol/Map.js';
import View from 'ol/View.js';
import {fromLonLat,transformExtent} from 'ol/proj.js';
import popup from './overlay/popup';
// Clear map
$("#map").html('');

//three brooks
var bsExtent = transformExtent(
  [-2.537, 51.530, -2.530, 51.536],
  'EPSG:4326', 'EPSG:3857'
);


const map = new Map({
  target: 'map',
  overlays: [popup],
  view: new View({
    center: fromLonLat([0,50]),
    zoom: 6,
//  extent: bsExtent,
  })
});

console.log('Create map:', map);
window.map=map;
export default map
